import { Flex, Grid, Text } from '@chakra-ui/react';
import React from 'react';

import { Icon } from 'packages/common-frontend/components/icons';
import { logout } from '~/contexts/UserAuthProvider';

type LogOutButtonProps = {
  iconOnly?: boolean;
  disableOnClick?: boolean;
};
export const LogOutButton = ({
  iconOnly,
  disableOnClick,
}: LogOutButtonProps) => {
  return (
    <Flex
      alignItems="center"
      onClick={disableOnClick ? undefined : () => logout()}
      cursor={disableOnClick ? undefined : 'pointer'}
    >
      {iconOnly && <Icon icon="arrow-right-from-bracket" size="medium" />}

      {!iconOnly && (
        <Flex alignItems="center" pl="10px">
          <Grid mr="12px" height={8} placeItems="center">
            <Icon icon="arrow-right-from-bracket" size="medium" />
          </Grid>
          <Text className="side-bar-item" fontSize="14px">
            Log Out
          </Text>
        </Flex>
      )}
    </Flex>
  );
};
